<template>
  <div id="app">
    <keep-alive :include="/^Nc/">
      <router-view/>
    </keep-alive>
    <van-tabbar active-color="#ff6400" inactive-color="#000" route v-if="$route.name == 'Main' || $route.name == 'My'">
      <van-tabbar-item replace to="/Main" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/My" icon="friends-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 14px;
}

#app * {
  box-sizing: border-box;
}

/*隐藏nprogress的loading效果*/
#nprogress .spinner {
  display: none;
}

.fx {
  display: flex !important;
}

.fx1 {
  flex: 1 1 0 !important;
}

.fx-row {
  display: flex !important;
  flex-direction: row !important;
}

.fx-col {
  display: flex !important;
  flex-direction: column !important;
}

/*内容展示不下时，不会自动收缩*/
.fx-shr0 {
  flex-shrink: 0;
}

.fx-col-cen {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
}

.fx-wrap {
  display: flex !important;
  flex-wrap: wrap !important;
}

.fx-np-wrap {
  display: flex !important;
  flex-wrap: nowrap !important;
}

.fx-sta {
  display: flex !important;
  justify-content: flex-start !important;
}

.fx-sta-sta {
  display: flex !important;
  justify-content: flex-start !important;
  align-items: flex-start !important;
}

.fx-sta-cen {
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
}

.fx-sta-end {
  display: flex !important;
  justify-content: flex-start !important;
  align-items: flex-end !important;
}

.fx-end {
  display: flex !important;
  justify-content: flex-end !important;
}

.fx-end-cen {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
}

.fx-end-end {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: flex-end !important;
}

.fx-cen {
  display: flex !important;
  justify-content: center !important;
}

.fx-cen-sta {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-start !important;
}

.fx-cen-end {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.fx-cen-cen {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

/*这个属性值会使第一个子元素靠最左边，最后一个子元素靠最右边，中间的子元素均匀分布在它们之间*/
.fx-bet {
  display: flex !important;
  justify-content: space-between !important;
}

.fx-bet-sta {
  display: flex !important;
  justify-content: space-between !important;
  align-items: flex-start !important;
}

.fx-bet-end {
  display: flex !important;
  justify-content: space-between !important;
  align-items: flex-end !important;
}

.fx-bet-cen {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}


/*每个子元素的左右两侧都有相同大小的空白空间，并且相邻元素之间的空白是元素两侧空白的两倍*/
.fx-aro {
  display: flex !important;
  justify-content: space-around !important;
  align-items: center !important;
}

.fx-aro-sta {
  display: flex !important;
  justify-content: space-around !important;
  align-items: flex-start !important;
}

.fx-aro-end {
  display: flex !important;
  justify-content: space-around !important;
  align-items: flex-end !important;
}

.fx-aro-cen {
  display: flex !important;
  justify-content: space-around !important;
  align-items: center !important;
}

/*所有子元素（包括第一个元素之前和最后一个元素之后）之间的空白空间是完全相等的*/
.fx-eve {
  display: flex;
  justify-content: space-evenly !important;
  align-items: stretch !important;
}

.fx-eve-sta {
  display: flex;
  justify-content: space-evenly !important;
  align-items: flex-start !important;
}

.fx-eve-end {
  display: flex;
  justify-content: space-evenly !important;
  align-items: flex-end !important;
}

.fx-eve-cen {
  display: flex;
  justify-content: space-evenly !important;
  align-items: center !important;
}

/*内容拉伸铺满*/
.fx-sth-sth {
  display: flex !important;
  justify-content: stretch !important;
  align-items: stretch !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue